<template>
  <div
    v-if="tilesLoading"
    class="map-tiles-loader"
    role="status"
    aria-label="Chargement des signalements"
    aria-live="polite"
  >
    <svg
      class="spinner"
      viewBox="0 0 50 50"
      aria-hidden="true"
    >
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      />
    </svg>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MapTilesLoader',

  computed: {
    ...mapState('map', [
      'tilesLoading',
    ]),
  },
};
</script>

<style lang="less" scoped>
.map-tiles-loader {
  position: absolute;
  right: 0.5em;
  bottom: 2.5em;
  z-index: 2;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5em;
  height: 2.5em;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.spinner {
  width: 1.5em;
  height: 1.5em;
  animation: spin 0.8s linear infinite;
}

.path {
  stroke: #00b5ad;
  stroke-linecap: round;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
